import { createElement, FC, RefObject } from 'react';

import ImageScreen from '../primitive/ImageScreen';
import VideoScreen from '../primitive/VideoScreen';
import PreviewVideoScreen from './PreviewVideoScreen';
interface Props {
  className?: string;
  mimeType: string;
  url?: string | null;
  videoRef?: RefObject<HTMLVideoElement>;
}
const MediaPlayer: FC<Props> = ({ className, videoRef, mimeType, url }) => {
  if (mimeType.startsWith('video/')) {
    return <PreviewVideoScreen src={url} className={className} videoRef={videoRef} controls nodownload />;
  } else if (mimeType.startsWith('image/')) {
    return <ImageScreen src={url} className={className} />;
  } else if (mimeType.startsWith('audio/')) {
    return <VideoScreen src={url!} className={className} videoRef={videoRef} controls nodownload />;
  } else {
    return null;
  }
};

export default MediaPlayer;
